import React, { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { EnvelopeSimple, Copy } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [newsletter, setNewsletter] = useState([]);
  const [tab, setTab] = useState("messages");

  useEffect(() => {
    api.get("/admin/contact-messages").then((r) => setMessages(r.data));
    api.get("/admin/newsletter").then((r) => setNewsletter(r.data));
  }, []);

  const copyEmails = () => {
    const emails = newsletter.map((n) => n.email).join(", ");
    navigator.clipboard.writeText(emails);
    toast.success(`Copied ${newsletter.length} emails`);
  };

  const exportCsv = () => {
    const csv = "email,subscribed_at\n" + newsletter.map((n) => `${n.email},${n.created_at}`).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "veloteka-newsletter.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-8 lg:p-12" data-testid="admin-messages">
      <div className="mb-8">
        <div className="overline text-[color:var(--vt-orange)] mb-2">/ INBOX</div>
        <h1 className="font-display font-black text-4xl tracking-tighter">Messages</h1>
      </div>

      <div className="flex gap-2 mb-6 border-b border-neutral-200">
        <button
          onClick={() => setTab("messages")}
          className={`px-4 py-2 text-sm font-bold uppercase tracking-wider border-b-2 ${tab === "messages" ? "border-[color:var(--vt-orange)] text-[color:var(--vt-orange)]" : "border-transparent text-neutral-500"}`}
          data-testid="tab-messages"
        >Contact Messages ({messages.length})</button>
        <button
          onClick={() => setTab("newsletter")}
          className={`px-4 py-2 text-sm font-bold uppercase tracking-wider border-b-2 ${tab === "newsletter" ? "border-[color:var(--vt-orange)] text-[color:var(--vt-orange)]" : "border-transparent text-neutral-500"}`}
          data-testid="tab-newsletter"
        >Newsletter ({newsletter.length})</button>
      </div>

      {tab === "messages" && (
        <div className="space-y-3">
          {messages.length === 0 ? (
            <div className="bg-white border border-neutral-200 p-12 text-center text-neutral-500">No messages yet.</div>
          ) : messages.map((m) => (
            <div key={m.id} className="bg-white border border-neutral-200 p-6">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <div className="font-bold">{m.subject}</div>
                  <div className="text-xs text-neutral-500">from {m.name} · {m.email} {m.phone && `· ${m.phone}`}</div>
                </div>
                <div className="text-xs text-neutral-500">{new Date(m.created_at).toLocaleString()}</div>
              </div>
              <p className="text-sm text-neutral-800 mt-2 whitespace-pre-wrap">{m.message}</p>
              <a href={`mailto:${m.email}?subject=Re: ${m.subject}`} className="inline-flex items-center gap-2 text-xs font-bold text-[color:var(--vt-orange)] mt-3 uppercase tracking-wider">
                <EnvelopeSimple size={14} /> Reply
              </a>
            </div>
          ))}
        </div>
      )}

      {tab === "newsletter" && (
        <div>
          <div className="flex gap-2 mb-4">
            <button onClick={copyEmails} className="vt-btn-outline text-xs" data-testid="copy-emails"><Copy size={14} /> Copy all emails</button>
            <button onClick={exportCsv} className="vt-btn-orange text-xs" data-testid="export-csv">Export CSV</button>
          </div>
          <div className="bg-white border border-neutral-200">
            {newsletter.length === 0 ? (
              <div className="p-12 text-center text-neutral-500">No subscribers yet.</div>
            ) : (
              <table className="w-full text-sm">
                <thead className="bg-neutral-50 border-b border-neutral-200">
                  <tr>
                    <th className="text-left p-3 overline text-neutral-600">Email</th>
                    <th className="text-left p-3 overline text-neutral-600">Subscribed</th>
                  </tr>
                </thead>
                <tbody>
                  {newsletter.map((n) => (
                    <tr key={n.id} className="border-b border-neutral-100">
                      <td className="p-3 font-mono text-xs">{n.email}</td>
                      <td className="p-3 text-xs text-neutral-500">{new Date(n.created_at).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
